import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/write-offs', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/write-offs/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/v1/write-offs/${data.write_off_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/write-offs/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateStatus = data => {
  return httpClient
    .put(`/api/v1/write-offs/update-status/${data.write_off_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getStockInNumber = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs/stock-in-numbers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uom = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs/uom', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productSearch = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs/search-products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCategoryAvailable = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs/category-available', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProductAvailable = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs/product-available', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productAvailableSearch = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs/product-available-search', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNewSerialByQty = (Options = {}) => {
  return httpClient
    .get('/api/v1/write-offs/new-serial-by-quantity', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const sysQty = productId => {
  return httpClient
    .get(`/api/v1/write-offs/${productId}/products`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  product,
  uom,
  updateStatus,
  productSearch,
  getCategoryAvailable,
  getProductAvailable,
  productAvailableSearch,
  getNewSerialByQty,
  getStockInNumber,
  sysQty
}
